// Interface

import util from '@/utils/classToObject'
import { IUmbTypeState } from './state'
import { AloDbUmbType } from '@/models/alodb/AloDbUmbType'

export class UmbTypeGetter {  
      
  public umbTypes(state:IUmbTypeState,getters:any) {
    return state.umbTypes
  }

  public modifiedAdmUmbType(state:IUmbTypeState,getters:any) {
    return state.modifiedAdmUmbType
  }

  public originalAdmUmbType(state:IUmbTypeState,getters:any) {
    return state.originalAdmUmbType
  }

  public umbTypeLoading(state:IUmbTypeState,getters:any) {
    return state.umbTypeLoading
  }

  public umbTypesById(state:IUmbTypeState) {     
    return state.umbTypes.reduce((acc,value) =>{
        acc[value.UMT_ID!] = value
        return acc
    },{}  as {[id:number]:AloDbUmbType})      
  }

  public umbTypeStatus(state:IUmbTypeState) {     
    return state.status
  }

  public adminUmbTypeFilter(state:IUmbTypeState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(UmbTypeGetter)